import { Navigate, useLocation } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const PrivateTeacherRouter = ({children}) => {
    const token = localStorage.getItem('jwt')
    const location = useLocation()
    let token_decode = null
    if (token && token !== 'undefined'){
        token_decode = jwtDecode(token)
        if (token_decode.rol === 'teacher'){
            if (token_decode.mustChangePassword && location.pathname !== '/teacher/change-password') {
                return <Navigate to="/teacher/change-password" replace />
            }
            return children
        } else {
            return <Navigate to="/" replace />
        }
    }
    return <Navigate to="/" replace />
}

export default PrivateTeacherRouter
